import { FailedTransaction } from '@/types/api/bankid/v2/transaction';
import { transactionErrorMessage } from '../utils/error-code-message';
import { CircleX } from 'lucide-react';
import { Button } from '@/components/originui/button';
import { TransactionErrorCode } from '@/types/api/bankid/v2/transaction-error-code.enum';

type TransactionFailedProps = {
  errorCode: TransactionErrorCode;
  reset: () => void;
};

export function TransactionFailed({ errorCode, reset }: TransactionFailedProps) {
  return (
    <>
      <CircleX size={40} color="red" />

      <h3 className="text-xl leading-relaxed font-semibold">BankID-Verifiering misslyckades</h3>

      <p className="text-base leading-7 text-gray-700 dark:text-gray-300">{transactionErrorMessage(errorCode)}</p>

      <Button variant={'outline'} onClick={reset}>
        Försök igen
      </Button>
    </>
  );
}
